import {TypedUseSelectorHook, useDispatch, useSelector} from "react-redux";
import type {RootState, AppDispatch} from "../store/store";

/**
 * Typed replacement for `useDispatch` Redux hook.
 * @returns - typed Redux dispatch function
 *
 * @example
 * const dispatch = useAppDispatch();
 */
const useAppDispatch = () => useDispatch<AppDispatch>();

/**
 * Typed replacement for `useSelector` Redux hook.
 * @param selector — the selector function
 * @param equalityFn — the function that will be used to determine equality
 * @returns — the selected state
 *
 * @example
 * const sessionId = useAppSelector(state => state.auth.sessionId);
 */
const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export {useAppDispatch, useAppSelector};
